// extracted by mini-css-extract-plugin
export default {"ldsDualRing":"Spinner_ldsDualRing__NPom4"};